<!--模板-->
<template>
  <div class="zwcWidth">
    <!-- 大背景 -->
    <div class="zwcWidth bg">
      <div class="flex">
        <!--<div class="shade">-->
          <!--<div style="display: table-cell;vertical-align: middle;text-align: center;">-->
            <h1 style="font-size: 85px;text-shadow:5px 2px 6px #000;">心愿众筹</h1>
            <h3 style="text-shadow:5px 2px 6px #000;">我有一个心愿，你可以帮我实现Ta嘛？～</h3>
            <!--&lt;!&ndash;<el-input placeholder="寻找其它目的地城市" v-model="input5" class="input-with-select">&ndash;&gt;-->
              <!--&lt;!&ndash;<el-button slot="append" icon="el-icon-search"></el-button>&ndash;&gt;-->
            <!--&lt;!&ndash;</el-input>&ndash;&gt;-->
          <!--</div>-->
        <!--</div>-->
      </div>
    </div>

    <!-- 分类 -->
    <div class="seconedWidth classify" >
      <h2>热门心愿</h2>
      <div class="border_b">
        <span></span>
        <p></p>
      </div>
      <p>我有一个心愿，你可以帮我实现Ta嘛？～</p>
    </div>

    <!-- //热门推荐-->
    <div class="jd_floor jd_floor2 similar clearfix">
      <div class="mid">
        <!--<div class="mt2"><img src="../../../static/images/spot-b2.png" /></div>-->
        <div class="mc2">
          <div class="jd_hot_body">
            <div class="lay-zone-cont2">
              <div class="jd-hotList-main mid--1000">
                <ul>
                  <li v-for="(item,index) of TravelList.data" :key="index"  @click="travelBtn(item)">
                    <em class="tag" v-if="item.thankMethod != 0"><i>{{item.thankMethod == 1 ? '代购' : item.thankMethod == 2 ? '抽奖' : item.thankMethod == 3 ?'代购+抽奖' : ''}}</i></em>
                    <a class="img" ><img :src="item.travelImg" height="250" width="320"></a>
                    <div class="spot_desc">
                      <div class="addr clearfix"><label class="fl">[愿望]  {{item.title}}</label> <a class="fr">详情»</a></div>
                      <div class="nums">
                        <em class="e1">已获 {{item.travelMappingMoney}}元</em>
                        <em class="e2"> </em>
                        <em class="e3">愿望 {{item.travelMoney}}元</em>
                      </div>
                    </div>
                    <div style="padding: 10px">
                      <el-progress :text-inside="true" :stroke-width="18" :percentage="(item.travelMoney > item.travelMappingMoney) ?  Math.floor(item.travelMappingMoney / item.travelMoney * 100) : 100  "></el-progress>
                    </div>
                  </li>
                </ul>
                <p style="text-align: right">
                  <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :current-page="page"
                    :page-sizes="[30, 50, 80, 100]"
                    :page-size="30"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalData">
                  </el-pagination>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!--JS-->
<script>
  import {selectTravelList} from '@/api/apis'
  import axios from 'axios'
  import $ from 'jquery'
  export default {
    data() {
      return {
        offsetCount: 0,
        input5:'',
        TravelList:'',
        totalData:0,
        page:1,
        pageSize:30
      }
    },
    methods:{
      handleSizeChange(val) {
        this.pageSize = val
        // 获取服务服务列表
        this.getList()
        console.log(`每页 ${val} 条`);
      },
      pageChange(val){
        this.page = val
        // 获取服务服务列表
        this.getList()
        console.log(this.page,val,"翻页")
      },
      travelBtn(item){
        this.$router.push('/homePage?nameCode=' + item.userCode + '&nameTravel=' + item.code)
      },
      // 获取列表
      getList(){
        let vm = this
        selectTravelList({
          nowPage:vm.page,
          nowPageDataNum:vm.pageSize,
          type:0
        }).then((res)=>{
          if(res.code == '000000'){
            vm.totalData = res.data.totalDataNum
            vm.TravelList = res.data
          } else {
            vm.$message.warning(res.msg)
          }
        })
      }
    },
    mounted(){
      let vm = this
      // 获取列表
      vm.getList()
    }
  }
</script>


<!--css样式-->
<style lang="scss" scoped>
  @import '../../scss/commonH5.scss';

  /*外层样式*/
  .zwcWidth{
    width:100%;
  }
  /*内层居中样式*/
  .seconedWidth{
    width:1270px;
    margin:0 auto;
  }

  // header头部
  #header {
    height: 80px;
    // padding: 30px 0;
  }
  #header>div:first-child {
    padding-top: 15px;
  }
  #header img {
    display: block;
    width: 120px;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: 0;
  }
  .el-menu.el-menu--horizontal li {
    padding: 0;
    margin: 0 20px;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }
  .el-menu.el-menu--horizontal li:last-child {
    margin-right: 0;
  }
  /*面包屑导航*/
  .el-breadcrumb {
    font-size: 14px;
    line-height: 1;
    text-align: right;
  }
  .el-breadcrumb span {
    float: inherit;
  }
  .r_nav {
    padding-top: 15px;
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px solid #FF6600;
    color: #FF6600;
    border-bottom-color: #FF6600 !important;
  }
  .el-breadcrumb[data-v-297fe81f] {
    font-size: 12px;
    line-height: 1;
    text-align: right;
  }
  /*导航下大背景*/
  .bg {
    background: url(../../../static/images/title/sponsor.jpg) no-repeat;
    background-size: 100% 130%;
    width: 100%;
    height: 500px;
    display: flex;
  }
  .bg .flex {
    align-self: center;
    margin: auto;
  }
  .bg .flex h1 {
    color: #ffffff;
    font-size: 30px;
    text-align: center;
  }
  .bg .flex h3 {
    color: #ffffff;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
  }
  .bg .flex .shade {
    width: 800px;
    height: 100px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    display: table;
    margin-top: 15px;
    padding-bottom: 30px;
  }
  .el-select .el-input {
    width: 80px;
  }
  .el-input-group {
    width: 93%;
  }
  .el-input-group__append {
    background-color: $fontColor !important;
    color: #ffffff;
    border: 0;
  }
  /*玩行分类*/
  .classify{
    padding: 60px 0 30px 0 ;
  }
  .classify h2{
    color: $fontColor;
    font-size: 25px;
    font-weight: 600;
    text-align: center;
  }
  .classify .border_b {
    margin: 10px 0;
  }
  .classify .border_b p{
    width: 250px;
    height: 1px;
    margin: auto;
    background-color: #E0DEDE;
  }
  .classify .border_b span {
    width: 25px;
    height: 2px;
    display: block;
    margin: auto;
    background-color: #2F2F2F;
  }
  .classify>p {
    color: #8D8A8A;
    text-align: center;
    font-size: 15px;
  }

  /* ==== 旅游景点页面 {{{ ==== */
  /*当季景点推荐*/
  .jd_floor2, .jd_floor4, .jd_floor6{ }
  .jd_floor{padding:0 0 150px 0;}
  .jd_floor .mc2{background:none!important;}
  .jd_floor .lay-zone-cont2{margin-top:30px;}
  .jd-list-main .sel-month{text-align:center;width:100%;}
  .jd-list-main .sel-month a{color:#999;cursor:pointer;font-size:16px;margin:0 15px;}
  .jd-list-main .sel-month a:hover{border-bottom:2px solid $fontColor;color:$fontColor;}
  .jd-list-main .sel-month a.on{border-bottom:2px solid $fontColor;color:$fontColor;font-weight:700;}
  .jd-list-main ul{display:inline-block;margin-right:-20px;}
  .jd-list-main ul li{float:left;margin-right:20px;margin-top:20px;overflow:hidden;height:235px;width:235px; position:relative;}
  .jd-list-main ul li img{display:block;border-top-left-radius:7px;border-top-right-radius:7px; transition:all 0.5s;-webkit-transition:all 0.5s;-moz-transition:all 0.5s;}
  .jd-list-main ul li a:hover img{opacity:0.8;filter:alpha(opacity=80);transform:translateY(1.03);-webkit-transform:scale(1.03);-moz-transform:scale(1.03);}
  .jd-list-main ul li .inner-info{text-align:center;height:100%;width:100%; position:absolute;top:0;left:0;}
  .jd-list-main ul li .inner-info .info{color:#fff;line-height:23px;margin-top:100px;}
  .jd-list-main ul li .inner-info .info h2{font-size:20px;}
  .jd-list-main ul li .inner-info .info span{font-size:20px;letter-spacing:2px;}
  .jd-list-main ul li .title{background:url(../../../static/images/icon-tit-bg.png) repeat;width:100%;position:absolute;bottom:0;}
  .jd-list-main ul li .title span{
    display:table-cell;vertical-align:middle;color:#fff;font-size:14px;padding:0 5px;text-align:center;height:42px;line-height:20px;width:225px;
  }
  /*热门景点推荐*/
  .jd-hotList-main ul{display:inline-block;margin-right:-20px;}
  .jd-hotList-main ul li{
    cursor: pointer;
    border-radius: 5px;
    background:#474664;float:left;overflow:hidden;margin-right:20px;margin-bottom:50px;width:300px; position:relative;
    box-shadow:0 2px 12px 0 rgba(0, 0, 0, 0.1);
    transition:all 0.3s;-webkit-transition:all 0.3s;-moz-transition:all 0.3s;
  }
  .jd-hotList-main ul li:hover{
    opacity:0.8;filter:alpha(opacity=80);
    transform:scale(1.03);-webkit-transform:scale(1.03);-moz-transform:scale(1.03);
    box-shadow: 2px 3px 5px #666;
  }
  .jd-hotList-main ul li .tag{background:url(../../../static/images/icon-label.png) no-repeat;color:#fff;font-size:18px;padding-left:8px;height:32px;z-index:10; position:absolute;top:20px;right:0;}
  .jd-hotList-main ul li .tag i{display:inline-block;padding:0 10px;height:32px;line-height:32px;background: #FF586B;}
  .jd-hotList-main ul li a.img{display:block;overflow:hidden;height:250px;width:320px;}
  .jd-hotList-main ul li a.img img{
    transition:all 0.3s;-webkit-transition:all 0.3s;-moz-transition:all 0.3s;
  }
  .jd-hotList-main ul li a.img:hover img{
    opacity:0.8;filter:alpha(opacity=80);
    transform:scale(1.03);-webkit-transform:scale(1.03);-moz-transform:scale(1.03);
  }
  .jd-hotList-main ul li .spot_desc{padding:5px 15px;}
  .jd-hotList-main ul li .spot_desc .addr{margin-top:3px;}
  .jd-hotList-main ul li .spot_desc .addr label{color:#fff;font-size:14px;width:88%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
  .jd-hotList-main ul li .spot_desc .addr a{color:$fontColor;font-size:12px;margin-top:1px;}
  .jd-hotList-main ul li .spot_desc .addr a:hover{text-decoration:underline;}
  .jd-hotList-main ul li .spot_desc .nums{margin-top:10px;margin-right:-1px;overflow:hidden;display: flex;justify-content: space-between}
  .jd-hotList-main ul li .spot_desc .nums em{border-right:1px solid #e8e8e8;color:#c4c3e6;display:inline;float:left;font-size:13px;width:30%;}
  .jd-hotList-main ul li .spot_desc .nums .e1{text-align:left;}
  .jd-hotList-main ul li .spot_desc .nums .e2{text-align:center;}
  .jd-hotList-main ul li .spot_desc .nums .e3{border-right:0;text-align:right;}
</style>



// WEBPACK FOOTER //
// src/views/sponsor/sponsorList.vue